import { useEffect } from 'react';

const useRateSearchLayout = (onLayoutChange: (layout: 'cards') => void) => {
  useEffect(() => {
    const syncListView = () => {
      if (window.innerWidth < 1200) onLayoutChange('cards');
    };

    syncListView();
    window.addEventListener('resize', syncListView);

    return () => window.removeEventListener('resize', syncListView);
  }, [onLayoutChange]);
};

export default useRateSearchLayout;
